import React, { useMemo } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { useSelector } from 'react-redux';
//slices
import { companySelector } from 'slices/company';
// HOC
import RequireAuth from '../HCOs/RequireAuth';
// layouts
import DefaultLayout from '../layouts/defaultLayout';
// pages
import HomePage from '../pages/home';
import BookDetail from '../pages/detail/index';
import OrderDetail from '../pages/orders/detail';
import ProfilePage from '../pages/profile';
import Cart from '../pages/cart';
import Shipping from '../pages/cart/shipping';
import Pay from '../pages/cart/pay';
import OkPayment from '../pages/cart/ok_payment';
import ErrorPayment from '../pages/cart/error_payment';
import CardDetail from '../pages/cardDetails';
import DynamicFilter from '../pages/dynamicFilter/';
import FavoritesPage from '../pages/favorites';
import AwardWinningBooksPage from 'pages/awardWinningBooksPage';
import { PostList } from '../pages/blog';
import Categoryblog from '../pages/blog/categoryblog';
import Post from '../pages/blog/post';
import RecoverPage from '../pages/recover';
import SendMailRecover from '../pages/recover/sendMailRecover';
import Libraries from '../pages/libraries/libraries';
import AboutUs from '../pages/about/AboutUs';
import GiftCard from '../pages/gift-card/GiftCard';
import Contact from '../pages/contact/Contact';
import PricesAndTerms from '../pages/infoPages/pricesAndTerms';
import HowToBuy from '../pages/infoPages/howToBuy';
import Refunds from '../pages/infoPages/refunds';
import Ebook from '../pages/infoPages/ebook';
import Faqs from '../pages/infoPages/faqs';
import Gallery from '../pages/gallery';
import TermsOfUse from '../pages/infoPages/termsOfUse';
import LegalsAndPrivacy from '../pages/infoPages/legalsAndPrivacy';
import Cookies from '../pages/infoPages/cookies';
import Register from '../pages/register/register';
import LoginPage from '../pages/login/loginPage';
import ChildrenBooks from '../pages/childrenBooks';
import List from '../pages/list';
import AwardedBooks from '../pages/awardedBooks';
import SmallReviews from '../pages/smallReviews';
import smallReviewsDetail from '../pages/smallReviewsDetail';
import Schedule from '../pages/schedule';
import EventDetail from '../pages/schedule/eventDetail';
import LibrariesMap from '../pages/mapsPage';
import NotFound from '../pages/notfound';
import MyBooksManager from '../pages/profile/myBooksManager/index';
import ExportFromDilve from '../pages/extras/exportFromDilve';
import OrderList from 'pages/order-list';
import OrderConfirmation from 'pages/orderConfirmation';
import PaymentFailed from 'pages/paymentFailed';
import LegalNoticePrivacyPolicy from 'pages/infoPages/legalNoticePrivacyPolicy';
import UsageConditions from 'pages/infoPages/usageConditions';
import LibraryDetail from 'pages/libraryDetail';

//Admin Panel
import HomePanel from '../pages/adminPanel/home';
import ProductsEdition from '../pages/adminPanel/productsEdition';
// import BooksOfTheMonth from '../components/blog/BooksOfTheMonth';
// import BooksOfTheMonthSection from '../components/blog/BooksOfTheMonthSection';

//Backoffice
import AdminIntranetLayout from '../layouts/adminIntranetLayout';
import IntranetLogin from 'pages/backoffice/login';
import Users from '../pages/backoffice/users/index';
import EditUser from '../pages/backoffice/users/edit/index';
import CreateUser from '../pages/backoffice/users/create/index';
import EmailSubscriptions from '../pages/backoffice/emailSuscriptions/index';
import Bookstores from '../pages/backoffice/bookstores/index';
import CreateBookStore from '../pages/backoffice/bookstores/create/index';
import EditBookStore from '../pages/backoffice/bookstores/edit/index';
import Coupons from '../pages/backoffice/coupons/index';
import Authors from '../pages/backoffice/authors/index';
import Editorials from '../pages/backoffice/editorials/index';
import EditorialDetail from '../pages/backoffice/editorials/item/edit';
import EditorialCreate from '../pages/backoffice/editorials/item/create';
import BooksOfTheMonthTable from '../pages/backoffice/booksOfTheMonth/index';
import BooksOfTheMonthPosts from '../pages/backoffice/booksOfTheMonthPosts/index';
import Comments from '../pages/backoffice/comments/index';
import Invoices from 'pages/backoffice/invoice';
import CreateInvoice from 'pages/backoffice/invoice/create';
import EditInvoice from 'pages/backoffice/invoice/edit';
import Lists from '../pages/backoffice/lists/index';
import CreateList from '../pages/backoffice/lists/create/index';
import EditList from '../pages/backoffice/lists/edit/index';
import AwardWinningBooks from '../pages/backoffice/awardWinningBooks/index';
import BlogPosts from '../pages/backoffice/blogPosts/index';
import FeedbackPage from '../pages/backoffice/feedbackPage';
/* import Orders from 'pages/backoffice/orders/index';
import OrderCreatePage from 'pages/backoffice/orders/OrderCreate';
import OrderEditPage from 'pages/backoffice/orders/OrderEdit'; */
import Contests from 'pages/backoffice/contests/index';
import CreateContest from 'pages/backoffice/contests/create/index';
import EditContest from 'pages/backoffice/contests/edit/index';
import Products from 'pages/backoffice/products/index';
import CreateProduct from 'pages/backoffice/products/create/index';
import EditProduct from 'pages/backoffice/products/edit/index';
import Client from 'pages/backoffice/client_messages/index';
import Schedules from 'pages/backoffice/schedules/index';
import CreateSchedules from 'pages/backoffice/schedules/create';
import EditSchedules from 'pages/backoffice/schedules/edit';
import Commissions from 'pages/backoffice/commissions/index';
import CommissionsByCompany from '../pages/backoffice/commissionsByCompany';
import GalleryManagement from 'pages/backoffice/gallery';
import HelpTextBackoffice from 'pages/backoffice/helpText';
import CreateHelpText from 'pages/backoffice/helpText/create';
import EditHelpText from 'pages/backoffice/helpText/edit';
import SlidersPage from '../pages/backoffice/sliders';
import FaqsPage from '../pages/backoffice/faqs';
import CreateFaq from '../pages/backoffice/faqs/FaqCreate';
import EditFaq from '../pages/backoffice/faqs/FaqEdit';
import PromotionalCodesPage from '../pages/backoffice/promotionalCodes';
import CreatePromotionalCodes from '../pages/backoffice/promotionalCodes/PromotionalCodesCreate';
import EditPromotionalCodes from '../pages/backoffice/promotionalCodes/PromotionalCodesEdit';
import Posts from '../pages/backoffice/posts';
import CreatePost from '../pages/backoffice/posts/create/index';
import EditPost from '../pages/backoffice/posts/edit/index';
import BlogCategories from '../pages/backoffice/blog-categories';
import CreateBlogCategory from '../pages/backoffice/blog-categories/create';
import EditBlogCategory from 'pages/backoffice/blog-categories/edit';
import HelpText from 'pages/infoPages/helpText';
import TypeSchedules from 'pages/backoffice/type-scheudules';
import CreateTypeSchedules from 'pages/backoffice/type-scheudules/create';
import EditTypeSchedules from 'pages/backoffice/type-scheudules/edit';
import Menu from 'pages/backoffice/menu';
import Deliveries from 'pages/backoffice/deliveries';
import CreateDeliveries from 'pages/backoffice/deliveries/create';
import EditDeliveries from 'pages/backoffice/deliveries/edit';
import MenuMatters from 'pages/backoffice/menuCategory';
import CreateMenuMatters from 'pages/backoffice/menuCategory/create';
import EditMenuMatters from 'pages/backoffice/menuCategory/edit';
import Configuration from 'pages/backoffice/configuration';
import AffiliationBackoffice from 'pages/backoffice/affiliation';
import CreateAffiliation from 'pages/backoffice/affiliation/create';
import EditAffiliation from 'pages/backoffice/affiliation/edit';
import CreateAwardWinningBook from 'pages/backoffice/awardWinningBooks/create';
import EditAwardWinningBook from 'pages/backoffice/awardWinningBooks/edit';
import Prueba from 'pages/backoffice/purchases';
import Purchases from 'pages/backoffice/purchases';
import OrderCreatePage from 'pages/backoffice/purchases/create';
import OrderEditPage from 'pages/backoffice/purchases/edit';

// Route Detector for cart reset
import ResetOnRouteChangeCartDiscount from '../components/routeDetector/ResetOnRouteChangeCartDiscount';
import Affiliate from 'pages/affiliate';
import CommentsLibrary from 'pages/backoffice/commentsLibrary';

const MainRoute = () => {
  const { slug } = useSelector(companySelector);

  const adminSubroutes = [
    {
      path: 'products',
      Component: Products,
    },
    {
      path: 'products/create',
      Component: CreateProduct,
    },
    {
      path: 'products/edit/:id',
      Component: EditProduct,
    },
    {
      path: 'comments',
      Component: Comments,
    },
    {
      path: 'coupons',
      Component: Coupons,
    },
    {
      path: 'invoices',
      Component: Invoices,
    },
    {
      path: 'invoices/create',
      Component: CreateInvoice,
    },
    {
      path: 'invoices/edit/:id',
      Component: EditInvoice,
    },
    {
      path: 'lists',
      Component: Lists,
    },
    {
      path: 'lists/create',
      Component: CreateList,
    },
    {
      path: 'lists/edit/:id',
      Component: EditList,
    },
    {
      path: 'users',
      Component: Users,
    },
    {
      path: 'users/edit/:id',
      Component: EditUser,
    },
    {
      path: 'users/create',
      Component: CreateUser,
    },
    {
      path: 'email-subscriptions',
      Component: EmailSubscriptions,
    },
    /*   {
        path: 'pedidos',
        Component: Orders,
      },
      {
        path: 'orders/create',
        Component: OrderCreatePage,
      },
      {
        path: 'orders/:id/edit/',
        Component: OrderEditPage,
      }, */
    {
      path: 'purchases',
      Component: Purchases,
    },
    {
      path: 'purchases/create',
      Component: OrderCreatePage,
    },
    {
      path: 'purchases/:id/edit/',
      Component: OrderEditPage,
    },
    {
      path: 'contests',
      Component: Contests,
    },
    {
      path: 'contests/create/',
      Component: CreateContest,
    },
    {
      path: 'contests/edit/:id',
      Component: EditContest,
    },
    { path: 'authors', Component: Authors },

    { path: 'bookstores', Component: Bookstores },
    {
      path: 'authors',
      Component: Authors,
    },
    {
      path: 'bookstores',
      Component: Bookstores,
    },
    {
      path: 'bookstores/create',
      Component: CreateBookStore,
    },
    {
      path: 'bookstores/edit/:id',
      Component: EditBookStore,
    },
    {
      path: 'posts',
      Component: Posts,
    },
    {
      path: 'posts/create',
      Component: CreatePost,
    },
    {
      path: 'posts/edit/:id',
      Component: EditPost,
    },
    {
      path: 'blog-categories',
      Component: BlogCategories,
    },
    {
      path: 'blog-categories/create',
      Component: CreateBlogCategory,
    },
    {
      path: 'blog-categories/edit/:id',
      Component: EditBlogCategory,
    },
    {
      path: 'editorials',
      Component: Editorials,
    },
    {
      path: 'editorials/:action/:id?',
      Component: EditorialDetail,
    },
    {
      path: 'editorials/create',
      Component: EditorialCreate,
    },
    {
      path: 'books-of-the-month',
      Component: BooksOfTheMonthTable,
    },
    {
      path: 'books-of-the-month-posts',
      Component: BooksOfTheMonthPosts,
    },
    {
      path: 'award-winning-books',
      Component: AwardWinningBooks,
    },
    {
      path: 'blog-posts',
      Component: BlogPosts,
    },
    {
      path: 'client-messages',
      Component: Client,
    },
    {
      path: 'schedules',
      Component: Schedules,
    },
    {
      path: 'schedules/create',
      Component: CreateSchedules,
    },
    {
      path: 'schedules/edit/:id',
      Component: EditSchedules,
    },
    {
      path: 'type-schedules',
      Component: TypeSchedules,
    },
    {
      path: 'type-schedules/create',
      Component: CreateTypeSchedules,
    },
    {
      path: 'type-schedules/edit/:id',
      Component: EditTypeSchedules,
    },
    {
      path: 'commissions',
      Component: Commissions,
    },
    {
      path: 'commissions-by-company',
      Component: CommissionsByCompany,
    },
    {
      path: 'gallery',
      Component: GalleryManagement,
    },
    {
      path: 'help-text',
      Component: HelpTextBackoffice,
    },
    {
      path: 'help-text/create',
      Component: CreateHelpText,
    },
    {
      path: 'help-text/edit/:id',
      Component: EditHelpText,
    },
    {
      path: 'affiliation-request',
      Component: AffiliationBackoffice,
    },
    {
      path: 'affiliation-request/create',
      Component: CreateAffiliation,
    },
    {
      path: 'affiliation-request/edit/:id',
      Component: EditAffiliation,
    },
    {
      path: 'award-winning-books/create',
      Component: CreateAwardWinningBook,
    },
    {
      path: 'award-winning-books/edit/:id',
      Component: EditAwardWinningBook,
    },
    {
      path: 'menu',
      Component: Menu,
    },
    {
      path: 'deliveries',
      Component: Deliveries,
    },
    {
      path: 'deliveries/create',
      Component: CreateDeliveries,
    },
    {
      path: 'deliveries/edit/:id',
      Component: EditDeliveries,
    },
    {
      path: 'menu-matters',
      Component: MenuMatters,
    },
    {
      path: 'menu-matters/create',
      Component: CreateMenuMatters,
    },
    {
      path: 'menu-matters/edit/:id',
      Component: EditMenuMatters,
    },
    // {
    //   path: 'login',
    //   Component: IntranetLogin,
    //   secured: true,
    // },
    {
      path: 'sliders',
      Component: SlidersPage,
    },
    {
      path: 'faqs',
      Component: FaqsPage,
    },
    {
      path: 'faqs/create',
      Component: CreateFaq,
    },
    {
      path: 'faqs/edit/:id',
      Component: EditFaq,
    },
    {
      path: 'promotionalCodes',
      Component: PromotionalCodesPage,
    },
    {
      path: 'promotionalCodes/create',
      Component: CreatePromotionalCodes,
    },
    {
      path: 'promotionalCodes/edit/:id',
      Component: EditPromotionalCodes,
    },
    {
      path: 'configuration',
      Component: Configuration
    },
    {
      path: 'comments-library',
      Component: CommentsLibrary,
    },
  ];
  // should be the last routes to render
  const workInProgressRoutes = [
    {
      path: ':subsection',
      Component: FeedbackPage,
    },
    {
      path: ':subsection/:action/:id?',
      Component: FeedbackPage,
    },
  ];

  adminSubroutes.push(...workInProgressRoutes);

  const userRoute = [
    {
      path: '',
      Component: HomePage,
    },
    {
      path: 'carrito',
      Component: Cart,
    },
    {
      path: 'envio',
      Component: Shipping,
    },
    {
      path: 'pago',
      Component: Pay,
    },
    {
      path: 'pago-ok',
      Component: OrderConfirmation,
    },
    {
      path: 'pago-error',
      Component: PaymentFailed,
    },
    {
      path: 'perfil',
      protected: true,
      Component: ProfilePage,
    },
    {
      path: 'filtro/:type/',
      Component: DynamicFilter,
    },
    // {
    //   path: 'productos/:id',
    //   Component: BookDetail,
    // },
    {
      path: 'autor/:id',
      Component: CardDetail,
    },
    {
      path: 'editorial/:id',
      Component: CardDetail,
    },
    {
      path: 'libro/:id',
      Component: BookDetail,
    },
    {
      path: 'pelicula/:id',
      Component: BookDetail,
    },
    {
      path: 'musica/:id',
      Component: BookDetail,
    },
    {
      path: 'merchandising/:id',
      Component: BookDetail,
    },
    {
      path: 'favoritos',
      Component: FavoritesPage,
    },
    {
      path: 'libros-premiados',
      Component: AwardWinningBooksPage,
    },
    {
      path: 'order-list',
      Component: OrderList,
    },
    {
      path: 'blog',
      Component: PostList,
    },
    {
      path: 'blog/:id/:category',
      Component: Categoryblog,
    },
    {
      path: 'blog/:year/:month/:day/:slug',
      Component: Post,
    },
    // {
    //   path: 'blog/category/:booksOfTheMonthId',
    //   Component: BooksOfTheMonth,
    // },
    // {
    //   path: 'blog/category/section/libros_del_mes',
    //   Component: BooksOfTheMonthSection,
    // },
    // {
    //   path: 'libelista/posts/:id', //! MODIFICAR URL LIBELISTA!
    //   Component: Post,
    // },
    {
      path: 'recuperar-contrasena/:uid/:token',
      Component: RecoverPage,
    },
    {
      path: 'recuperar-contrasena',
      Component: SendMailRecover,
    },
    {
      path: 'mis-libros',
      Component: MyBooksManager,
      protected: true,
    },
    {
      path: 'mis-pedidos/:pk/',
      Component: OrderDetail,
      protected: true,
    },
    {
      path: 'librerias',
      Component: Libraries,
    },
    {
      path: 'library/:id',
      Component: LibraryDetail,
    },
    {
      path: 'sobre-nosotros',
      Component: AboutUs,
    },
    {
      path: 'contacto',
      Component: Contact,
    },
    {
      path: 'tarjeta-regalo',
      Component: GiftCard,
    },
    {
      path: 'tarifas-y-plazos-de-entrega',
      Component: PricesAndTerms,
    },
    {
      path: 'como-comprar',
      Component: HowToBuy,
    },
    {
      path: 'ayuda/:id/:slug',
      Component: HelpText,
    },
    {
      path: 'devoluciones-y-anulaciones',
      Component: Refunds,
    },
    {
      path: 'ebook',
      Component: Ebook,
    },
    {
      path: 'faqs',
      Component: Faqs,
    },
    {
      path: 'gallery',
      Component: Gallery,
    },
    {
      path: 'condiciones-de-uso',
      Component: TermsOfUse,
    },
    {
      path: 'aviso-legal-y-politica-de-privacidad',
      Component: LegalsAndPrivacy,
    },
    {
      path: 'cookies',
      Component: Cookies,
    },
    {
      path: 'registro',
      Component: Register,
    },
    {
      path: 'inicio-sesion',
      Component: LoginPage,
    },
    {
      path: 'para-infantil',
      Component: ChildrenBooks,
    },
    {
      path: 'afiliate',
      Component: Affiliate
    },
    {
      path: 'lista/:type',
      Component: List,
    },
    {
      path: 'lista/:type/:id',
      Component: List,
    },
    {
      path: 'premiados',
      Component: AwardedBooks,
    },
    {
      path: 'pequeno-libelista', //! MODIFICAR URL LIBELISTA!
      Component: SmallReviews,
    },
    {
      path: 'pequenas-resenas',
      Component: smallReviewsDetail,
    },
    {
      path: 'agenda',
      Component: Schedule,
    },
    {
      path: 'agenda/:id',
      Component: EventDetail,
    },
    {
      path: 'librerias/mapa',
      Component: LibrariesMap,
    },
    {
      path: 'export-from-dilve',
      Component: ExportFromDilve,
    },
    {
      path: 'aviso-legal-politica-privacidad',
      Component: LegalNoticePrivacyPolicy,
    },
    {
      path: 'condiciones-de-uso/nuevas-condiciones',
      Component: UsageConditions,
    },
  ];

  const ProtectedRoutes = ({ adminSubroutes }) => {
    const protectedRoutes = useMemo(() => {
      return adminSubroutes.map(({ path, Component }, index) => (
        <Route
          key={`route${path}#${index}`}
          exact
          protected
          path={path}
          element={
            <RequireAuth>
              <Component />
            </RequireAuth>
          }
        />
      ));
    }, [adminSubroutes]);

    return <>{protectedRoutes}</>;
  };

  return (
    <Router>
      <ResetOnRouteChangeCartDiscount>
        <Routes>
          <Route path="/" element={<DefaultLayout />}>
            {userRoute.map(({ path, Component }, index) => (
              <Route key={`route${path}#${index}`} exact protected path={
                path === 'pago-ok' || path === 'pago-error'
                  ? path 
                  : path !== ''
                    ? `${slug}/${path}` 
                    : path

              } element={<Component />} />
            ))}
          </Route>
          <Route
            path={`/intranet/`}
            element={
              <RequireAuth>
                <AdminIntranetLayout />
              </RequireAuth>
            }
          >
            <Route exact path="" protected={true} Component={HomePanel} />
            <Route exact path="products/edition/:id" protected={true} element={<ProductsEdition />} />
            {/* <Route Component={<ProtectedRoutes />} /> */}
            {adminSubroutes.map(({ path, Component }, index) => (
              <Route key={`route${path}#${index}`} exact protected path={path} element={<Component />} />
            ))}
          </Route>

          <Route exact path="/intranet/login" protected={true} Component={IntranetLogin} />
          <Route path="*" Component={NotFound} />
        </Routes>
      </ResetOnRouteChangeCartDiscount>
    </Router>
  );
};
export default MainRoute;